// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__G353U","doneBtn":"styles_doneBtn__jDuY5","count":"styles_count__fPwyD"};